function getBundleAdjustedTotals(cart) {
  let childrenFinal = 0;
  let parentsOriginal = 0;

  (cart.items || []).forEach((item) => {
    const properties = item.properties || {};
    const isChild = String(properties._is_part_of_bundle) === 'true';
    const isParent = Boolean(properties._bundle_instance);

    if (isChild) {
      childrenFinal += item.final_line_price || 0;
    } else if (isParent) {
      parentsOriginal += item.original_line_price || 0;
    }
  });

  const displayedOriginal = Math.max(0, (cart.original_total_price || 0) - parentsOriginal);
  const displayedTotal = Math.max(0, (cart.total_price || 0) - childrenFinal);

  return {
    displayedOriginal,
    displayedTotal,
    displayedSavings: Math.max(0, displayedOriginal - displayedTotal)
  };
}

function formatCartMoney(cents, currency) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD'
  }).format(cents / 100);
}

document.addEventListener('cart:discount-applied', (event) => {
  const cart = event.detail?.cart;
  if (!cart) return;

  const totals = getBundleAdjustedTotals(cart);
  const totalElement = document.querySelector('.cart-drawer .cart-drawer__footer-inner .h-stack.justify-between .medium');
  if (totalElement) {
    totalElement.textContent = formatCartMoney(totals.displayedTotal, cart.currency);
  }

  const discountContainer = document.querySelector('.cart-drawer .v-stack.gap-1.5');
  if (discountContainer && cart.cart_level_discount_applications) {
    discountContainer.querySelectorAll('.h-stack.justify-between.gap-4').forEach((el) => {
      if (el.querySelector('.icon-discount')) {
        el.remove();
      }
    });

    cart.cart_level_discount_applications.forEach((discount) => {
      const discountElement = document.createElement('div');
      discountElement.className = 'h-stack justify-between gap-4';
      discountElement.innerHTML = `
        <span class="h-stack gap-2">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 2.5L2.5 9.5M3.5 2.5H9.5V8.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${discount.title}
        </span>
        <span class="text-subdued">-${formatCartMoney(discount.total_allocated_amount, cart.currency)}</span>
      `;

      const totalRow = discountContainer.querySelector('.h-stack.justify-between.gap-4:last-child');
      if (totalRow) {
        totalRow.parentNode.insertBefore(discountElement, totalRow);
      }
    });
  }
});

document.addEventListener('cart:discount-removed', () => {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
});

function bindRemoveDiscountButtons() {
  document.querySelectorAll('.remove-discount-btn').forEach((btn) => {
    if (btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', () => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: '' })
      }).then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindRemoveDiscountButtons);
} else {
  bindRemoveDiscountButtons();
}

document.addEventListener('cart:change', bindRemoveDiscountButtons);
